let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("aCh9P"), load("bxxT5"), load("bRMot"), load("fwPOR")]).then(() => parcelRequire('3EFzM'));